import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions';
import isMobile from '../../utils/isMobile';
import * as modeUtils from '../../utils/mode.js';
import Icon from '@mdi/react';
import { mdiWindowClose, mdiBug } from '../../images/svg';

function ChatHeader({
  title, baseParams, mode, hideCloseButton, clickDebuggerButton, clickCloseButton, webPluginMode, fontSize, toggleFontSize, useFontSizeToggle, HeaderContent, messages
}) {
  const headerStyle = {
    color: baseParams.headerTextColor,
    backgroundColor: baseParams.headerBackgroundColor
  };
  const chatHeaderClassNames = classNames(
    'cu-ui-chat-header',
    !!HeaderContent && "cu-ui-chat-header-custom",
    fontSize === 'large' ? 'cu-ui-font-size-large' : 'cu-ui-font-size-default',
  );
  const chatHeaderLeftButtonClass = classNames(
    'button-group',
    {
      'hide': !mode || isMobile()
    }
  );
  const chatHeaderRightCloseButtonClass = classNames(
    'cu-ui-button cu-ui-outline',
    {
      'hide': (
        modeUtils.inspect(webPluginMode).embedded ||
        hideCloseButton
      )
    }
  );
  const customCss = {
    color: baseParams.headerTextColor,
    fontSize: baseParams.headerFontSize,
    textShadow: baseParams.headerTextShadow
  };


  const renderFontSizeToggle = () => {
    if (!useFontSizeToggle) {
      return null;
    }
    return (
      <div className="font-size-toggle">
        <div
          className={classNames({ 'active': fontSize === 'default' })}
          onClick={() => toggleFontSize('default')}
          tabIndex="0"
        >
          標準
        </div>
        <div
          className={classNames({ 'active': fontSize === 'large' })}
          onClick={() => toggleFontSize('large')}
          tabIndex="0"
        >
          大
        </div>
      </div>
    );
  };

  const renderDefaultContent = () => {
    return (
      <React.Fragment>
        <div className='left'>
          <div
            className={chatHeaderLeftButtonClass}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <button className={'cu-ui-button cu-ui-outline'} onClick={() => { clickDebuggerButton(); }}>
              <Icon path={mdiBug} size={1} />
            </button>
          </div>
        </div>
        <div className='center'>
          <div className={'cu-ui-title'} style={customCss}>
            {title}
          </div>
        </div>
        <div className='right'>
          {renderFontSizeToggle()}
          <div
            className={'button-group'}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <button className={chatHeaderRightCloseButtonClass} onClick={() => { clickCloseButton(); }}>
              <Icon path={mdiWindowClose} size={1} />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const renderCustomContent = () => {
    return (
      <HeaderContent
        title={title}
        messages={messages}
        renderFontSizeToggle={renderFontSizeToggle}
      />
    );
  };

  return (
    <div className={chatHeaderClassNames} style={headerStyle}>
      {HeaderContent ? (
        renderCustomContent()
      ) : (
        renderDefaultContent()
      )}
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  title: state.chatRoot.title,
  baseParams: state.chatRoot.baseParams,
  hideCloseButton: state.chatRoot.hideCloseButton,
  webPluginMode: state.chatRoot.webPluginMode,
  fontSize: state.chatRoot.fontSize,
  useFontSizeToggle: state.chatRoot.useFontSizeToggle,

  HeaderContent: state.chatRoot.components.HeaderContent,
  messages: state.chatBody.messages,
  title: state.chatRoot.title
});

const mapDispatchToProps = (dispatch) => {
  return {
    clickDebuggerButton: bindActionCreators(actions.clickDebuggerButton, dispatch),
    clickCloseButton: bindActionCreators(actions.clickCloseButton, dispatch),
    toggleFontSize: bindActionCreators(actions.toggleFontSize, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatHeader);
